"use client";
import { FC } from "react";

interface IconEyeProps {
  className?: string;
}

const IconEye: FC<IconEyeProps> = ({ className }) => {
  return (
    <svg
      className={`icon-eye ${className}`}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_419_18843)">
        <path
          className="eye"
          d="M10.0004 3.33325C13.5754 3.33325 16.5529 5.35742 18.8879 9.29492L19.0712 9.61075L19.1087 9.69409L19.1337 9.76325L19.1454 9.80909L19.157 9.87742L19.1662 9.96075V10.0524L19.1545 10.1449C19.1491 10.1759 19.1418 10.2065 19.1329 10.2366L19.1004 10.3266L19.0704 10.3891L19.057 10.4141C16.7537 14.4441 13.807 16.5641 10.2612 16.6633L10.0004 16.6666C6.33705 16.6666 3.30288 14.5424 0.943716 10.4133C0.871807 10.2874 0.833984 10.1449 0.833984 9.99992C0.833984 9.85494 0.871807 9.71247 0.943716 9.58659C3.30288 5.45742 6.33705 3.33325 10.0004 3.33325ZM10.0004 7.49992C9.33734 7.49992 8.70146 7.76331 8.23261 8.23215C7.76377 8.70099 7.50038 9.33688 7.50038 9.99992C7.50038 10.663 7.76377 11.2988 8.23261 11.7677C8.70146 12.2365 9.33734 12.4999 10.0004 12.4999C10.6634 12.4999 11.2993 12.2365 11.7681 11.7677C12.237 11.2988 12.5004 10.663 12.5004 9.99992C12.5004 9.33688 12.237 8.70099 11.7681 8.23215C11.2993 7.76331 10.6634 7.49992 10.0004 7.49992Z"
          fill="#FF3448"
        />
      </g>
      <defs>
        <clipPath id="clip0_419_18843">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconEye;
